export default __webpack_public_path__ + "static/error-404-00b3916dfbfb4062567405b340a89f79.svg";